/**
 * ポーリング設定
 */
export const POLLING_CONFIG = {
  /** ポーリング間隔（ミリ秒） */
  interval: 2000,
  /** 最大リトライ回数 */
  maxRetries: 30,
} as const;

/**
 * ファイルアップロード設定
 */
export const FILE_UPLOAD_CONFIG = {
  /** 許可されるファイルタイプ */
  accept: { 'application/pdf': ['.pdf'] },
  /** 最大ファイルサイズ（20MB） */
  maxSize: 20 * 1024 * 1024,
} as const;
